/* This file was generated by `yarn gen-graphql-internal`. Don't edit it directly */

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A string that must be alphanumeric */
  AlphaNumericString: { input: string; output: string };
  /** ISO 8601 Date e.g. `1969-07-21` */
  Date: { input: string; output: string };
  /** ISO 8601 DateTime e.g. `1969-07-16T13:32:00.000Z`. You can also provide a date e.g. `1969-01-01` and it will be converted to `1969-01-01T00:00:00.000Z` */
  DateTime: { input: string; output: string };
  /** The first moment of a specific year, month or day or hour e.g. 1969 or 1969-1 or 1969-1-1 or 1969-1-1T00. All of the previous examples are equivalent to `1969-1-1T00:00:00.000`. */
  FirstMoment: { input: string; output: string };
  /** A string representing integers up to 9,223,372,036,854,775,807 (i.e. 2^63-1) */
  Int64: { input: string; output: string };
  /** A string representing integers as big as 2^120-1. The number is signed so the range is from -1,329,227,995,784,915,872,903,807,060,280,344,575 to 1,329,227,995,784,915,872,903,807,060,280,344,575. */
  Int96: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: string; output: string };
  /** The last moment of a specific year, month or day or hour e.g. 1969 or 1969-12 or 1969-12-31 or 1969-12-31T23. All of the previous examples are equivalent to `1969-12-31T23:59:59.999`. */
  LastMoment: { input: string; output: string };
  /** A string of non-zero length that can contain parameterized values via handlebars syntax. ex: `"Hello from {{country}}"`. */
  ParameterizedString: { input: string; output: string };
  /** A mapping of parameter keys to values. */
  Parameters: { input: string; output: string };
  /** A specific year ("2021"), quarter ("2021-Q1"), month ("2021-02"), day ("2021-02-03") or hour ("2021-02-03T04") */
  Period: { input: string; output: string };
  /** A specific year ("2026") or month ("2026-05") used to match dates that fall within it. */
  PeriodFilter: { input: string; output: string };
  /** A string with delimiter characters `/`, `#`, and `:` disallowed, as well as parameters in {{handlebar}} syntax. */
  SafeString: { input: string; output: string };
  /** All hour-aligned offsets from -11:00 to +12:00 are supported, e.g. "-08:00" (PT), "-05:00" (ET), "+00:00" (UTC) */
  UTCOffset: { input: string; output: string };
};

export type ApiClient = {
  __typename?: 'ApiClient';
  clientName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: WorkspaceRoleKey;
};

export type AuthLinkUnit = {
  __typename?: 'AuthLinkUnit';
  env: LinkUnitEnv;
  id: Scalars['ID']['output'];
  unitOrgId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AuthLinkUnitResponse = AuthLinkUnitResult | BadRequestError | InternalError;

export type AuthLinkUnitResult = {
  __typename?: 'AuthLinkUnitResult';
  authLink: AuthLinkUnit;
};

export type AuthorizeIndividualLegalEntityBasisTheorySessionResponse =
  | AuthorizeIndividualLegalEntityBasisTheorySessionResult
  | BadRequestError
  | InternalError;

export type AuthorizeIndividualLegalEntityBasisTheorySessionResult = {
  __typename?: 'AuthorizeIndividualLegalEntityBasisTheorySessionResult';
  success: Scalars['Boolean']['output'];
};

export type AuthorizePlatformEntityBasisTheorySessionResponse =
  | AuthorizePlatformEntityBasisTheorySessionResult
  | BadRequestError
  | InternalError;

export type AuthorizePlatformEntityBasisTheorySessionResult = {
  __typename?: 'AuthorizePlatformEntityBasisTheorySessionResult';
  success: Scalars['Boolean']['output'];
};

/** Equivalent to an HTTP 400 - request either has missing or incorrect data */
export type BadRequestError = Error & {
  __typename?: 'BadRequestError';
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

export type BnkDevTempLink = {
  __typename?: 'BnkDevTempLink';
  id: Scalars['ID']['output'];
};

export type BusinessCdd = {
  __typename?: 'BusinessCDD';
  allowsCrossBorder?: Maybe<Scalars['Boolean']['output']>;
  beneficialOwners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessEntityId?: Maybe<Scalars['ID']['output']>;
  buyerSellerConnection?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Scalars['String']['output']>;
  clientIp?: Maybe<Scalars['String']['output']>;
  countriesOfOperation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasUndergoneSignificantChanges?: Maybe<Scalars['Boolean']['output']>;
  holdFinancialLicenses?: Maybe<Scalars['Boolean']['output']>;
  industryVertical?: Maybe<Scalars['String']['output']>;
  instance: Scalars['Int']['output'];
  isRegulatedIndustry?: Maybe<Scalars['Boolean']['output']>;
  licenses?: Maybe<Array<Maybe<BusinessCddLicense>>>;
  sellersAsIntermediaries?: Maybe<Scalars['Boolean']['output']>;
  strategicPartners?: Maybe<Scalars['String']['output']>;
  structure?: Maybe<Scalars['String']['output']>;
  termsAgreedAt?: Maybe<Scalars['String']['output']>;
  termsUrl?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['ID']['output'];
};

export type BusinessCddLicense = {
  __typename?: 'BusinessCDDLicense';
  number: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BusinessCddLicenseInput = {
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessLegalEntity = {
  __typename?: 'BusinessLegalEntity';
  controllers?: Maybe<Array<IndividualLegalEntity>>;
  id: Scalars['String']['output'];
  owners?: Maybe<Array<IndividualLegalEntity>>;
  piiDataTokenId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CreateApiClientResponse = BadRequestError | CreateApiClientResult | InternalError;

export type CreateApiClientResult = {
  __typename?: 'CreateApiClientResult';
  client: ApiClient;
  secret: Scalars['String']['output'];
  workspace: Workspace;
};

export type CreateCustomLinkResponse = BadRequestError | CreateCustomLinkResult | InternalError;

export type CreateCustomLinkResult = {
  __typename?: 'CreateCustomLinkResult';
  isIkReplay: Scalars['Boolean']['output'];
  link: CustomLink | IncreaseLink | StripeLink | UnitLink;
};

export type CreateDataExportInput = {
  exportBucketKey?: InputMaybe<Scalars['String']['input']>;
  exportBucketName: Scalars['String']['input'];
  exportBucketRegion: Scalars['String']['input'];
  exportTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
};

export type CreateDataExportResponse = BadRequestError | CreateDataExportResult | InternalError;

export type CreateDataExportResult = {
  __typename?: 'CreateDataExportResult';
  dataExport: DataExport;
  workspace: Workspace;
};

export type CreateLiveBlocksTokenResponse =
  | BadRequestError
  | CreateLiveBlocksTokenResult
  | InternalError
  | NotFoundError;

export type CreateLiveBlocksTokenResult = {
  __typename?: 'CreateLiveBlocksTokenResult';
  accessToken: Scalars['String']['output'];
  roomId: Scalars['String']['output'];
};

export type CreateMcpAuthorizationGrantResponse = BadRequestError | CreateMcpAuthorizationGrantResult | InternalError;

export type CreateMcpAuthorizationGrantResult = {
  __typename?: 'CreateMcpAuthorizationGrantResult';
  grantToken: Scalars['String']['output'];
};

export type CreatePlatformOnboardingApplicationResponse =
  | BadRequestError
  | CreatePlatformOnboardingApplicationResult
  | InternalError;

export type CreatePlatformOnboardingApplicationResult = {
  __typename?: 'CreatePlatformOnboardingApplicationResult';
  platformEntity: BusinessLegalEntity;
};

export type CreateUserInput = {
  authId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  workspaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateWorkspaceAccessResponse = BadRequestError | CreateWorkspaceAccessResult | InternalError;

export type CreateWorkspaceAccessResult = {
  __typename?: 'CreateWorkspaceAccessResult';
  success: Scalars['Boolean']['output'];
  workspaceAccess?: Maybe<WorkspaceAccess>;
};

export type CreateWorkspaceSettingsResponse = BadRequestError | CreateWorkspaceSettingsResult | InternalError;

export type CreateWorkspaceSettingsResult = {
  __typename?: 'CreateWorkspaceSettingsResult';
  success: Scalars['Boolean']['output'];
  workspace: Workspace;
  workspaceAccess: WorkspaceAccess;
};

/**
 * An existing Stripe customer for the new workspace to share, in place of
 * provisioning one. Callers resolve it from the workspace the new one descends
 * from, which may live in another pod.
 */
export type CreateWorkspaceSettingsStripeCustomerInput = {
  stripeCustomerId: Scalars['String']['input'];
  stripeMode: Scalars['String']['input'];
};

export type CreateWorkspaceSettingsUserInput = {
  authId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkspaceSettingsWorkspaceInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mode: PaymentMode;
  name: Scalars['String']['input'];
  type?: InputMaybe<WorkspaceType>;
};

export enum CurrencyCode {
  Aave = 'AAVE',
  Ada = 'ADA',
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bch = 'BCH',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btc = 'BTC',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cadc = 'CADC',
  Cadt = 'CADT',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Custom = 'CUSTOM',
  Cve = 'CVE',
  Czk = 'CZK',
  Dai = 'DAI',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eth = 'ETH',
  Eur = 'EUR',
  Eurc = 'EURC',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ggp = 'GGP',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Imp = 'IMP',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Link = 'LINK',
  Lkr = 'LKR',
  Logical = 'LOGICAL',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltc = 'LTC',
  Lyd = 'LYD',
  Mad = 'MAD',
  Matic = 'MATIC',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pts = 'PTS',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sle = 'SLE',
  Sll = 'SLL',
  Sol = 'SOL',
  Sos = 'SOS',
  Spl = 'SPL',
  Srd = 'SRD',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Tvd = 'TVD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Uni = 'UNI',
  Usd = 'USD',
  Usdc = 'USDC',
  Usdg = 'USDG',
  Usdt = 'USDT',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xlm = 'XLM',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
}

export type CustomLink = Link & {
  __typename?: 'CustomLink';
  created: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
  originalName: Scalars['String']['output'];
};

export type DataExport = {
  __typename?: 'DataExport';
  exportBucketKey?: Maybe<Scalars['String']['output']>;
  exportBucketName: Scalars['String']['output'];
  exportBucketRegion: Scalars['String']['output'];
  exportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastPublishedExportTimestamp?: Maybe<Scalars['String']['output']>;
};

export type DeleteApiClientResponse = BadRequestError | DeleteApiClientResult | InternalError;

export type DeleteApiClientResult = {
  __typename?: 'DeleteApiClientResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteDataExportResponse = BadRequestError | DeleteDataExportResult | InternalError;

export type DeleteDataExportResult = {
  __typename?: 'DeleteDataExportResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteMcpClientResponse = BadRequestError | DeleteMcpClientResult | InternalError;

export type DeleteMcpClientResult = {
  __typename?: 'DeleteMcpClientResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteWorkspaceAccessResponse = BadRequestError | DeleteWorkspaceAccessResult | InternalError;

export type DeleteWorkspaceAccessResult = {
  __typename?: 'DeleteWorkspaceAccessResult';
  success: Scalars['Boolean']['output'];
};

export enum Entity {
  BnkDevLink = 'BnkDevLink',
  CustomLink = 'CustomLink',
  StripeLink = 'StripeLink',
  UnitLink = 'UnitLink',
}

/** Base error interface */
export type Error = {
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

export type GetIndividualEntityResult = {
  __typename?: 'GetIndividualEntityResult';
  individualEntity: IndividualLegalEntity;
};

export type GetPaymentPlatformEntityResult = {
  __typename?: 'GetPaymentPlatformEntityResult';
  businessCdd: BusinessCdd;
  platformEntity: BusinessLegalEntity;
};

export type IncreaseLink = Link & {
  __typename?: 'IncreaseLink';
  created: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
  increaseEnv: OnboardBnkDevEnv;
  originalName: Scalars['String']['output'];
};

export type IndividualEntityResponse = BadRequestError | GetIndividualEntityResult | InternalError | NotFoundError;

export type IndividualLegalEntity = {
  __typename?: 'IndividualLegalEntity';
  id: Scalars['String']['output'];
  piiDataTokenId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export enum IndividualOnboardingRole {
  Both = 'Both',
  Controller = 'Controller',
  Owner = 'Owner',
}

/** Equivalent to an HTTP 5XX - something went wrong with our API. */
export type InternalError = Error & {
  __typename?: 'InternalError';
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

export type InviteIndividualOnboardingApplicationResponse =
  | BadRequestError
  | InternalError
  | InviteIndividualOnboardingApplicationResult;

export type InviteIndividualOnboardingApplicationResult = {
  __typename?: 'InviteIndividualOnboardingApplicationResult';
  individualEntity: IndividualLegalEntity;
};

export enum InvoiceStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  Void = 'void',
}

export type Link = {
  created: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
  originalName: Scalars['String']['output'];
};

export type LinkBnkDevResponse = BadRequestError | InternalError | LinkBnkDevResult;

export type LinkBnkDevResult = {
  __typename?: 'LinkBnkDevResult';
  link?: Maybe<BnkDevTempLink>;
};

export type LinkResponse =
  | BadRequestError
  | CustomLink
  | IncreaseLink
  | InternalError
  | NotFoundError
  | StripeLink
  | UnitLink;

export enum LinkUnitEnv {
  Production = 'production',
  Sandbox = 'sandbox',
}

export type LinkUnitResponse = BadRequestError | InternalError | LinkUnitResult;

export type LinkUnitResult = {
  __typename?: 'LinkUnitResult';
  link: CustomLink | IncreaseLink | StripeLink | UnitLink;
};

export type ListWorkspaceMembersResponse = BadRequestError | InternalError | ListWorkspaceMembersResult | NotFoundError;

export type ListWorkspaceMembersResult = {
  __typename?: 'ListWorkspaceMembersResult';
  nodes: Array<WorkspaceMember>;
  pageInfo: PageInfo;
};

export type McpClient = {
  __typename?: 'McpClient';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  authLinkUnit?: Maybe<AuthLinkUnitResponse>;
  authorizeIndividualLegalEntityBasisTheorySession?: Maybe<AuthorizeIndividualLegalEntityBasisTheorySessionResponse>;
  authorizePlatformEntityBasisTheorySession?: Maybe<AuthorizePlatformEntityBasisTheorySessionResponse>;
  createApiClient?: Maybe<CreateApiClientResponse>;
  createCustomLink?: Maybe<CreateCustomLinkResponse>;
  createDataExport?: Maybe<CreateDataExportResponse>;
  createLiveBlocksReadToken?: Maybe<CreateLiveBlocksTokenResponse>;
  createLiveBlocksWriteToken?: Maybe<CreateLiveBlocksTokenResponse>;
  /**
   * Mints a short-lived, single-use grant token attesting that the calling
   * user is logged in to the workspace. The dashboard's MCP consent screen
   * forwards it to the MCP OpenAuth issuer to complete an authorization.
   */
  createMcpAuthorizationGrant?: Maybe<CreateMcpAuthorizationGrantResponse>;
  createPlatformOnboardingApplication?: Maybe<CreatePlatformOnboardingApplicationResponse>;
  createWorkspaceAccess?: Maybe<CreateWorkspaceAccessResponse>;
  createWorkspaceSettings?: Maybe<CreateWorkspaceSettingsResponse>;
  deleteApiClient?: Maybe<DeleteApiClientResponse>;
  deleteDataExport?: Maybe<DeleteDataExportResponse>;
  deleteMcpClient?: Maybe<DeleteMcpClientResponse>;
  deleteWorkspaceAccess?: Maybe<DeleteWorkspaceAccessResponse>;
  inviteIndividualOnboardingApplication?: Maybe<InviteIndividualOnboardingApplicationResponse>;
  linkBnkDev?: Maybe<LinkBnkDevResponse>;
  linkUnit?: Maybe<LinkUnitResponse>;
  onboardBnkDev?: Maybe<OnboardBnkDevResponse>;
  onboardStripe?: Maybe<OnboardStripeResponse>;
  saveSchemaDraft: SaveSchemaDraftResponse;
  submitBusinessEntityForReview?: Maybe<SubmitBusinessEntityForReviewResponse>;
  submitUBOForReview?: Maybe<SubmitUboForReviewResponse>;
  testDataExportConnection?: Maybe<TestDataExportConnectionResponse>;
  updateApiClient?: Maybe<UpdateApiClientResponse>;
  updateBusinessCDD?: Maybe<UpdateBusinessCddResponse>;
  updateStripeLink: UpdateStripeLinkResponse;
  updateUnitLink: UpdateUnitLinkResponse;
  updateWorkspace?: Maybe<UpdateWorkspaceResponse>;
  updateWorkspaceAccess?: Maybe<UpdateWorkspaceAccessResponse>;
};

export type MutationAuthLinkUnitArgs = {
  env: LinkUnitEnv;
  unitOrgId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type MutationAuthorizeIndividualLegalEntityBasisTheorySessionArgs = {
  entityId: Scalars['ID']['input'];
  nonce: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationAuthorizePlatformEntityBasisTheorySessionArgs = {
  nonce: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateApiClientArgs = {
  clientName: Scalars['String']['input'];
  role: WorkspaceRoleKey;
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateCustomLinkArgs = {
  ik: Scalars['SafeString']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateDataExportArgs = {
  dataExport: CreateDataExportInput;
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateLiveBlocksReadTokenArgs = {
  roomId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateLiveBlocksWriteTokenArgs = {
  roomId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateMcpAuthorizationGrantArgs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  issuerState: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreatePlatformOnboardingApplicationArgs = {
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateWorkspaceAccessArgs = {
  authId: Scalars['String']['input'];
  role: WorkspaceRoleKey;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationCreateWorkspaceSettingsArgs = {
  stripeCustomer?: InputMaybe<CreateWorkspaceSettingsStripeCustomerInput>;
  user: CreateWorkspaceSettingsUserInput;
  workspace: CreateWorkspaceSettingsWorkspaceInput;
};

export type MutationDeleteApiClientArgs = {
  clientId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationDeleteDataExportArgs = {
  dataExportId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationDeleteMcpClientArgs = {
  clientId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationDeleteWorkspaceAccessArgs = {
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationInviteIndividualOnboardingApplicationArgs = {
  email: Scalars['String']['input'];
  role: IndividualOnboardingRole;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationLinkBnkDevArgs = {
  code: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationLinkUnitArgs = {
  disableSync?: InputMaybe<Scalars['Boolean']['input']>;
  env: LinkUnitEnv;
  name: Scalars['String']['input'];
  orgToken: Scalars['String']['input'];
  unitOrgId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationOnboardBnkDevArgs = {
  disableSync?: InputMaybe<Scalars['Boolean']['input']>;
  env: OnboardBnkDevEnv;
  name?: InputMaybe<Scalars['String']['input']>;
  tempLinkId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationOnboardStripeArgs = {
  code: Scalars['String']['input'];
  disableSync?: InputMaybe<Scalars['Boolean']['input']>;
  env: StripeEnv;
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type MutationSaveSchemaDraftArgs = {
  author: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  schemaKey: Scalars['SafeString']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationSubmitBusinessEntityForReviewArgs = {
  legalEntityId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationSubmitUboForReviewArgs = {
  businessEntityId: Scalars['ID']['input'];
  identificationMethod: UboIdentificationMethod;
  legalEntityId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationTestDataExportConnectionArgs = {
  bucketName: Scalars['String']['input'];
  bucketRegion?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateApiClientArgs = {
  clientId: Scalars['ID']['input'];
  role: WorkspaceRoleKey;
  workspaceId: Scalars['ID']['input'];
};

export type MutationUpdateBusinessCddArgs = {
  businessCdd: UpdateBusinessCddInput;
  instance: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MutationUpdateStripeLinkArgs = {
  input: UpdateStripeLinkInput;
};

export type MutationUpdateUnitLinkArgs = {
  input: UpdateUnitLinkInput;
};

export type MutationUpdateWorkspaceArgs = {
  update: UpdateWorkspaceInput;
  workspaceId: Scalars['ID']['input'];
};

export type MutationUpdateWorkspaceAccessArgs = {
  role: WorkspaceRoleKey;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** Equivalent to an HTTP 404 */
export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

export enum OnboardBnkDevEnv {
  Production = 'production',
  Sandbox = 'sandbox',
}

export type OnboardBnkDevResponse = BadRequestError | InternalError | OnboardBnkDevResult;

export type OnboardBnkDevResult = {
  __typename?: 'OnboardBnkDevResult';
  link?: Maybe<CustomLink | IncreaseLink | StripeLink | UnitLink>;
};

export type OnboardStripeResponse = BadRequestError | InternalError | OnboardStripeResult;

export type OnboardStripeResult = {
  __typename?: 'OnboardStripeResult';
  link?: Maybe<CustomLink | IncreaseLink | StripeLink | UnitLink>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaymentAccount = {
  __typename?: 'PaymentAccount';
  accountName: Scalars['String']['output'];
  accountPath: Scalars['String']['output'];
  ledgerId: Scalars['ID']['output'];
  ledgerName: Scalars['String']['output'];
  mode: PaymentMode;
  verification?: Maybe<PaymentAccountVerification>;
};

export type PaymentAccountVerification = {
  __typename?: 'PaymentAccountVerification';
  isVerified: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export enum PaymentMode {
  Production = 'production',
  Sandbox = 'sandbox',
}

export type PaymentPlatformEntityResponse =
  | BadRequestError
  | GetPaymentPlatformEntityResult
  | InternalError
  | NotFoundError;

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  individualEntity?: Maybe<IndividualEntityResponse>;
  listWorkspaceMembers?: Maybe<ListWorkspaceMembersResponse>;
  paymentPlatformEntity?: Maybe<PaymentPlatformEntityResponse>;
  schemaDraft: SchemaDraftResponse;
  schemaDrafts: SchemaDraftConnection;
  workspace?: Maybe<WorkspaceResponse>;
};

export type QueryIndividualEntityArgs = {
  entityId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type QueryListWorkspaceMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type QueryPaymentPlatformEntityArgs = {
  workspaceId: Scalars['ID']['input'];
};

export type QuerySchemaDraftArgs = {
  created: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  schemaKey: Scalars['SafeString']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type QuerySchemaDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  schemaKey: Scalars['SafeString']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input'];
};

export type ReversiblePageInfo = {
  __typename?: 'ReversiblePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type SaveSchemaDraftResponse = BadRequestError | InternalError | SaveSchemaDraftResult;

export type SaveSchemaDraftResult = {
  __typename?: 'SaveSchemaDraftResult';
  draft: SchemaDraft;
};

export type SchemaDraft = {
  __typename?: 'SchemaDraft';
  author: Scalars['String']['output'];
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  json: Scalars['JSON']['output'];
  schemaKey: Scalars['SafeString']['output'];
};

export type SchemaDraftConnection = {
  __typename?: 'SchemaDraftConnection';
  nodes: Array<SchemaDraft>;
  pageInfo: ReversiblePageInfo;
};

export type SchemaDraftMatchInput = {
  id: Scalars['ID']['input'];
};

export type SchemaDraftResponse = BadRequestError | InternalError | NotFoundError | SchemaDraft;

export enum StripeEnv {
  Livemode = 'livemode',
  Testmode = 'testmode',
}

export type StripeLink = Link & {
  __typename?: 'StripeLink';
  created: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
  originalName: Scalars['String']['output'];
  rakLastUpdated?: Maybe<Scalars['String']['output']>;
  stripeEnv: StripeEnv;
};

export type SubmitBusinessEntityForReviewResponse = BadRequestError | InternalError | SubmitEntityForReviewResult;

export type SubmitEntityForReviewResult = {
  __typename?: 'SubmitEntityForReviewResult';
  entityId: Scalars['String']['output'];
  oscilarWorkflowId: Scalars['String']['output'];
};

export type SubmitUboForReviewResponse = BadRequestError | InternalError | SubmitEntityForReviewResult;

export type TempLink = {
  __typename?: 'TempLink';
  id: Scalars['ID']['output'];
  institutionName: Scalars['String']['output'];
};

export type TestDataExportConnectionResponse = BadRequestError | InternalError | TestDataExportConnectionResult;

export type TestDataExportConnectionResult = {
  __typename?: 'TestDataExportConnectionResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum UboIdentificationMethod {
  DriversLicense = 'drivers_license',
  IndividualTaxpayerIdentificationNumber = 'individual_taxpayer_identification_number',
  Passport = 'passport',
  SocialSecurityNumber = 'social_security_number',
}

export enum UnitEnv {
  Production = 'production',
  Sandbox = 'sandbox',
}

export type UnitLink = Link & {
  __typename?: 'UnitLink';
  created: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
  orgTokenLastUpdated?: Maybe<Scalars['String']['output']>;
  originalName: Scalars['String']['output'];
  unitEnv: UnitEnv;
};

export type UpdateApiClientResponse = BadRequestError | InternalError | UpdateApiClientResult;

export type UpdateApiClientResult = {
  __typename?: 'UpdateApiClientResult';
  client: ApiClient;
};

export type UpdateBusinessCddInput = {
  allowsCrossBorder?: InputMaybe<Scalars['Boolean']['input']>;
  beneficialOwners?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyerSellerConnection?: InputMaybe<Scalars['String']['input']>;
  changes?: InputMaybe<Scalars['String']['input']>;
  countriesOfOperation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasUndergoneSignificantChanges?: InputMaybe<Scalars['Boolean']['input']>;
  holdFinancialLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  industryVertical?: InputMaybe<Scalars['String']['input']>;
  isRegulatedIndustry?: InputMaybe<Scalars['Boolean']['input']>;
  licenses?: InputMaybe<Array<InputMaybe<BusinessCddLicenseInput>>>;
  sellersAsIntermediaries?: InputMaybe<Scalars['Boolean']['input']>;
  strategicPartners?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<Scalars['String']['input']>;
  termsAgreedAt?: InputMaybe<Scalars['String']['input']>;
  termsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessCddResponse = BadRequestError | InternalError | UpdateBusinessCddResult;

export type UpdateBusinessCddResult = {
  __typename?: 'UpdateBusinessCDDResult';
  businessCdd: BusinessCdd;
};

export type UpdateStripeLinkInput = {
  linkId: Scalars['ID']['input'];
  rak: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type UpdateStripeLinkResponse = BadRequestError | InternalError | UpdateStripeLinkResult;

export type UpdateStripeLinkResult = {
  __typename?: 'UpdateStripeLinkResult';
  link?: Maybe<StripeLink>;
};

export type UpdateUnitLinkInput = {
  disableSync?: InputMaybe<Scalars['Boolean']['input']>;
  linkId: Scalars['ID']['input'];
  orgToken: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type UpdateUnitLinkResponse = BadRequestError | InternalError | UpdateUnitLinkResult;

export type UpdateUnitLinkResult = {
  __typename?: 'UpdateUnitLinkResult';
  link?: Maybe<UnitLink>;
};

export type UpdateWorkspaceAccessResponse = BadRequestError | InternalError | UpdateWorkspaceAccessResult;

export type UpdateWorkspaceAccessResult = {
  __typename?: 'UpdateWorkspaceAccessResult';
  member: WorkspaceMember;
  success: Scalars['Boolean']['output'];
};

export type UpdateWorkspaceInput = {
  defaultCurrency?: InputMaybe<CurrencyCode>;
  name?: InputMaybe<Scalars['String']['input']>;
  octaneCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceResponse = BadRequestError | InternalError | UpdateWorkspaceResult;

export type UpdateWorkspaceResult = {
  __typename?: 'UpdateWorkspaceResult';
  workspace: Workspace;
};

export type Workspace = {
  __typename?: 'Workspace';
  adminEmail?: Maybe<Scalars['String']['output']>;
  apiClients?: Maybe<WorkspaceApiClientsResponse>;
  dataExports?: Maybe<WorkspaceDataExportsResponse>;
  defaultCurrency: CurrencyCode;
  id: Scalars['ID']['output'];
  inviteCode?: Maybe<Scalars['String']['output']>;
  inviteEnabled?: Maybe<Scalars['Boolean']['output']>;
  invoices?: Maybe<WorkspaceInvoicesResponse>;
  link?: Maybe<LinkResponse>;
  links?: Maybe<WorkspaceLinksResponse>;
  mcpClients?: Maybe<WorkspaceMcpClientsResponse>;
  mode: PaymentMode;
  name: Scalars['String']['output'];
  octaneCustomerId?: Maybe<Scalars['String']['output']>;
  paymentAccounts?: Maybe<Array<PaymentAccount>>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeMode?: Maybe<Scalars['String']['output']>;
  tempLinks?: Maybe<WorkspaceTempLinksResponse>;
  token: Scalars['String']['output'];
  type: WorkspaceType;
};

export type WorkspaceLinkArgs = {
  id: Scalars['ID']['input'];
};

export type WorkspaceAccess = {
  __typename?: 'WorkspaceAccess';
  authId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceApiClientsResponse = BadRequestError | InternalError | NotFoundError | WorkspaceApiClientsResult;

export type WorkspaceApiClientsResult = {
  __typename?: 'WorkspaceApiClientsResult';
  nodes: Array<ApiClient>;
};

export type WorkspaceDataExportsResponse = BadRequestError | InternalError | NotFoundError | WorkspaceDataExportsResult;

export type WorkspaceDataExportsResult = {
  __typename?: 'WorkspaceDataExportsResult';
  nodes: Array<DataExport>;
};

export type WorkspaceInvoice = {
  __typename?: 'WorkspaceInvoice';
  amount: Scalars['Int96']['output'];
  billingPeriod: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  status: InvoiceStatus;
};

export type WorkspaceInvoicesConnection = {
  __typename?: 'WorkspaceInvoicesConnection';
  nodes: Array<WorkspaceInvoice>;
};

export type WorkspaceInvoicesResponse = BadRequestError | InternalError | NotFoundError | WorkspaceInvoicesConnection;

export type WorkspaceLinksConnection = {
  __typename?: 'WorkspaceLinksConnection';
  nodes: Array<CustomLink | IncreaseLink | StripeLink | UnitLink>;
};

export type WorkspaceLinksResponse = BadRequestError | InternalError | NotFoundError | WorkspaceLinksConnection;

export type WorkspaceMcpClientsResponse = BadRequestError | InternalError | NotFoundError | WorkspaceMcpClientsResult;

export type WorkspaceMcpClientsResult = {
  __typename?: 'WorkspaceMcpClientsResult';
  nodes: Array<McpClient>;
};

export type WorkspaceMember = {
  __typename?: 'WorkspaceMember';
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: WorkspaceRoleKey;
};

export type WorkspaceResponse = BadRequestError | InternalError | NotFoundError | Workspace;

export enum WorkspaceRoleKey {
  FreeTierAdmin = 'free_tier_admin',
  FreeTierReader = 'free_tier_reader',
  WorkspaceAdmin = 'workspace_admin',
  WorkspaceReader = 'workspace_reader',
}

export type WorkspaceTempLinksConnection = {
  __typename?: 'WorkspaceTempLinksConnection';
  nodes: Array<TempLink>;
};

export type WorkspaceTempLinksResponse = BadRequestError | InternalError | NotFoundError | WorkspaceTempLinksConnection;

export enum WorkspaceType {
  FreeTierLedger = 'free_tier_ledger',
  Ledger = 'ledger',
  Payments = 'payments',
}

export type CreateApiClientMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  clientName: Scalars['String']['input'];
  role: WorkspaceRoleKey;
}>;

export type CreateApiClientMutation = {
  __typename?: 'Mutation';
  createApiClient?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | {
        __typename: 'CreateApiClientResult';
        secret: string;
        client: { __typename?: 'ApiClient'; id: string; clientName: string; role: WorkspaceRoleKey };
      }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type DeleteApiClientMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
}>;

export type DeleteApiClientMutation = {
  __typename?: 'Mutation';
  deleteApiClient?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'DeleteApiClientResult'; success: boolean }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

type OnError_BadRequestError_Fragment = { __typename: 'BadRequestError'; code: string; message: string };

type OnError_InternalError_Fragment = { __typename: 'InternalError'; code: string; message: string };

type OnError_NotFoundError_Fragment = { __typename: 'NotFoundError'; code: string; message: string };

export type OnErrorFragment =
  | OnError_BadRequestError_Fragment
  | OnError_InternalError_Fragment
  | OnError_NotFoundError_Fragment;

export type GetWorkspaceApiClientQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type GetWorkspaceApiClientQuery = {
  __typename?: 'Query';
  workspace?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | {
        __typename: 'Workspace';
        apiClients?:
          | { __typename: 'BadRequestError'; code: string; message: string }
          | { __typename: 'InternalError'; code: string; message: string }
          | { __typename: 'NotFoundError'; code: string; message: string }
          | {
              __typename: 'WorkspaceApiClientsResult';
              nodes: Array<{ __typename?: 'ApiClient'; id: string; clientName: string; role: WorkspaceRoleKey }>;
            }
          | null;
      }
    | null;
};

export type UpdateApiClientMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  role: WorkspaceRoleKey;
}>;

export type UpdateApiClientMutation = {
  __typename?: 'Mutation';
  updateApiClient?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'UpdateApiClientResult';
        client: { __typename?: 'ApiClient'; id: string; clientName: string; role: WorkspaceRoleKey };
      }
    | null;
};

export type CreateDataExportMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  dataExport: CreateDataExportInput;
}>;

export type CreateDataExportMutation = {
  __typename?: 'Mutation';
  createDataExport?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | {
        __typename: 'CreateDataExportResult';
        dataExport: { __typename?: 'DataExport'; id: string; exportBucketName: string };
      }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type DeleteDataExportMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  dataExportId: Scalars['String']['input'];
}>;

export type DeleteDataExportMutation = {
  __typename?: 'Mutation';
  deleteDataExport?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'DeleteDataExportResult'; success?: boolean | null }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type GetDataExportsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type GetDataExportsQuery = {
  __typename?: 'Query';
  workspace?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | {
        __typename: 'Workspace';
        dataExports?:
          | { __typename: 'BadRequestError'; code: string; message: string }
          | { __typename: 'InternalError'; code: string; message: string }
          | { __typename: 'NotFoundError'; code: string; message: string }
          | {
              __typename: 'WorkspaceDataExportsResult';
              nodes: Array<{
                __typename?: 'DataExport';
                id: string;
                exportBucketName: string;
                exportBucketRegion: string;
                exportBucketKey?: string | null;
              }>;
            }
          | null;
      }
    | null;
};

export type TestDataExportConnectionMutationVariables = Exact<{
  bucketName: Scalars['String']['input'];
  bucketRegion?: InputMaybe<Scalars['String']['input']>;
}>;

export type TestDataExportConnectionMutation = {
  __typename?: 'Mutation';
  testDataExportConnection?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'TestDataExportConnectionResult'; success: boolean; errorMessage?: string | null }
    | null;
};

export type GetWorkspaceInvoicesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type GetWorkspaceInvoicesQuery = {
  __typename?: 'Query';
  workspace?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | {
        __typename: 'Workspace';
        invoices?:
          | { __typename: 'BadRequestError'; code: string; message: string }
          | { __typename: 'InternalError'; code: string; message: string }
          | { __typename: 'NotFoundError'; code: string; message: string }
          | {
              __typename: 'WorkspaceInvoicesConnection';
              nodes: Array<{
                __typename: 'WorkspaceInvoice';
                id: string;
                amount: string;
                billingPeriod: string;
                status: InvoiceStatus;
              }>;
            }
          | null;
      }
    | null;
};

type OnboardOnError_BadRequestError_Fragment = { __typename?: 'BadRequestError'; code: string; message: string };

type OnboardOnError_InternalError_Fragment = { __typename?: 'InternalError'; code: string; message: string };

type OnboardOnError_NotFoundError_Fragment = { __typename?: 'NotFoundError'; code: string; message: string };

export type OnboardOnErrorFragment =
  | OnboardOnError_BadRequestError_Fragment
  | OnboardOnError_InternalError_Fragment
  | OnboardOnError_NotFoundError_Fragment;

export type CreateCustomLinkMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  ik: Scalars['SafeString']['input'];
}>;

export type CreateCustomLinkMutation = {
  __typename?: 'Mutation';
  createCustomLink?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | {
        __typename: 'CreateCustomLinkResult';
        isIkReplay: boolean;
        link:
          | { __typename?: 'CustomLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename?: 'IncreaseLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename?: 'StripeLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename?: 'UnitLink'; id: string; entity: Entity; originalName: string; created: string };
      }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type GetLinkQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  linkId: Scalars['ID']['input'];
}>;

export type GetLinkQuery = {
  __typename?: 'Query';
  workspace?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | {
        __typename: 'Workspace';
        link?:
          | { __typename: 'BadRequestError'; code: string; message: string }
          | { __typename: 'CustomLink'; id: string; created: string; name: string }
          | { __typename: 'IncreaseLink'; increaseEnv: OnboardBnkDevEnv; id: string; created: string; name: string }
          | { __typename: 'InternalError'; code: string; message: string }
          | { __typename: 'NotFoundError'; code: string; message: string }
          | {
              __typename: 'StripeLink';
              stripeEnv: StripeEnv;
              rakLastUpdated?: string | null;
              id: string;
              created: string;
              name: string;
            }
          | {
              __typename: 'UnitLink';
              unitEnv: UnitEnv;
              orgTokenLastUpdated?: string | null;
              id: string;
              created: string;
              name: string;
            }
          | null;
      }
    | null;
};

export type LinkIncreaseMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;

export type LinkIncreaseMutation = {
  __typename?: 'Mutation';
  linkBnkDev?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'LinkBnkDevResult'; link?: { __typename?: 'BnkDevTempLink'; id: string } | null }
    | null;
};

export type LinkUnitMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  unitOrgId: Scalars['ID']['input'];
  env: LinkUnitEnv;
  disableSync?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orgToken: Scalars['String']['input'];
}>;

export type LinkUnitMutation = {
  __typename?: 'Mutation';
  linkUnit?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'LinkUnitResult';
        link:
          | { __typename?: 'CustomLink'; id: string; entity: Entity; created: string; originalName: string }
          | { __typename?: 'IncreaseLink'; id: string; entity: Entity; created: string; originalName: string }
          | { __typename?: 'StripeLink'; id: string; entity: Entity; created: string; originalName: string }
          | { __typename?: 'UnitLink'; id: string; entity: Entity; created: string; originalName: string };
      }
    | null;
};

export type OnboardIncreaseMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  tempLinkId: Scalars['ID']['input'];
  env: OnboardBnkDevEnv;
  disableSync?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnboardIncreaseMutation = {
  __typename?: 'Mutation';
  onboardBnkDev?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'OnboardBnkDevResult';
        link?:
          | { __typename: 'CustomLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename: 'IncreaseLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename: 'StripeLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename: 'UnitLink'; id: string; entity: Entity; originalName: string; created: string }
          | null;
      }
    | null;
};

export type OnboardStripeMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  env: StripeEnv;
  disableSync?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnboardStripeMutation = {
  __typename?: 'Mutation';
  onboardStripe?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'OnboardStripeResult';
        link?:
          | { __typename: 'CustomLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename: 'IncreaseLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename: 'StripeLink'; id: string; entity: Entity; originalName: string; created: string }
          | { __typename: 'UnitLink'; id: string; entity: Entity; originalName: string; created: string }
          | null;
      }
    | null;
};

export type UpdateStripeLinkMutationVariables = Exact<{
  update: UpdateStripeLinkInput;
}>;

export type UpdateStripeLinkMutation = {
  __typename?: 'Mutation';
  updateStripeLink:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'UpdateStripeLinkResult';
        link?: {
          __typename?: 'StripeLink';
          id: string;
          created: string;
          stripeEnv: StripeEnv;
          rakLastUpdated?: string | null;
          name: string;
        } | null;
      };
};

export type UpdateUnitLinkMutationVariables = Exact<{
  update: UpdateUnitLinkInput;
}>;

export type UpdateUnitLinkMutation = {
  __typename?: 'Mutation';
  updateUnitLink:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'UpdateUnitLinkResult';
        link?: {
          __typename?: 'UnitLink';
          id: string;
          created: string;
          unitEnv: UnitEnv;
          orgTokenLastUpdated?: string | null;
          name: string;
        } | null;
      };
};

export type CreateLiveBlocksReadTokenMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  roomId: Scalars['String']['input'];
}>;

export type CreateLiveBlocksReadTokenMutation = {
  __typename?: 'Mutation';
  createLiveBlocksReadToken?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'CreateLiveBlocksTokenResult'; accessToken: string; roomId: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | null;
};

export type CreateLiveBlocksWriteTokenMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  roomId: Scalars['String']['input'];
}>;

export type CreateLiveBlocksWriteTokenMutation = {
  __typename?: 'Mutation';
  createLiveBlocksWriteToken?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'CreateLiveBlocksTokenResult'; accessToken: string; roomId: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | null;
};

export type CreateMcpAuthorizationGrantMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  issuerState: Scalars['String']['input'];
  clientName?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateMcpAuthorizationGrantMutation = {
  __typename?: 'Mutation';
  createMcpAuthorizationGrant?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'CreateMcpAuthorizationGrantResult'; grantToken: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type DeleteMcpClientMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
}>;

export type DeleteMcpClientMutation = {
  __typename?: 'Mutation';
  deleteMcpClient?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'DeleteMcpClientResult'; success: boolean }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type GetWorkspaceMcpClientsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type GetWorkspaceMcpClientsQuery = {
  __typename?: 'Query';
  workspace?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | {
        __typename: 'Workspace';
        mcpClients?:
          | { __typename: 'BadRequestError'; code: string; message: string }
          | { __typename: 'InternalError'; code: string; message: string }
          | { __typename: 'NotFoundError'; code: string; message: string }
          | {
              __typename: 'WorkspaceMcpClientsResult';
              nodes: Array<{ __typename?: 'McpClient'; id: string; name: string; userId: string }>;
            }
          | null;
      }
    | null;
};

export type GetWorkspaceByIdQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type GetWorkspaceByIdQuery = {
  __typename?: 'Query';
  workspace?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | {
        __typename: 'Workspace';
        id: string;
        inviteEnabled?: boolean | null;
        inviteCode?: string | null;
        defaultCurrency: CurrencyCode;
        name: string;
      }
    | null;
};

export type GetIndividualEntityQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
}>;

export type GetIndividualEntityQuery = {
  __typename?: 'Query';
  individualEntity?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | {
        __typename: 'GetIndividualEntityResult';
        individualEntity: {
          __typename?: 'IndividualLegalEntity';
          id: string;
          type: string;
          piiDataTokenId?: string | null;
          status: string;
          userId?: string | null;
        };
      }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | null;
};

export type GetPaymentPlatformEntityQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type GetPaymentPlatformEntityQuery = {
  __typename?: 'Query';
  paymentPlatformEntity?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | {
        __typename: 'GetPaymentPlatformEntityResult';
        platformEntity: {
          __typename?: 'BusinessLegalEntity';
          id: string;
          type: string;
          piiDataTokenId: string;
          status: string;
          controllers?: Array<{
            __typename?: 'IndividualLegalEntity';
            id: string;
            type: string;
            status: string;
            userId?: string | null;
          }> | null;
          owners?: Array<{
            __typename?: 'IndividualLegalEntity';
            id: string;
            type: string;
            status: string;
            userId?: string | null;
          }> | null;
        };
        businessCdd: {
          __typename?: 'BusinessCDD';
          workspaceId: string;
          instance: number;
          businessEntityId?: string | null;
          structure?: string | null;
          description?: string | null;
          isRegulatedIndustry?: boolean | null;
          holdFinancialLicenses?: boolean | null;
          hasUndergoneSignificantChanges?: boolean | null;
          changes?: string | null;
          strategicPartners?: string | null;
          industryVertical?: string | null;
          buyerSellerConnection?: string | null;
          sellersAsIntermediaries?: boolean | null;
          allowsCrossBorder?: boolean | null;
          countriesOfOperation?: Array<string | null> | null;
          beneficialOwners?: Array<string | null> | null;
          termsAgreedAt?: string | null;
          termsUrl?: string | null;
          created: string;
          licenses?: Array<{ __typename?: 'BusinessCDDLicense'; type: string; number: string } | null> | null;
        };
      }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | null;
};

export type InviteIndividualOnboardingApplicationMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role: IndividualOnboardingRole;
}>;

export type InviteIndividualOnboardingApplicationMutation = {
  __typename?: 'Mutation';
  inviteIndividualOnboardingApplication?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'InviteIndividualOnboardingApplicationResult';
        individualEntity: {
          __typename?: 'IndividualLegalEntity';
          id: string;
          type: string;
          piiDataTokenId?: string | null;
          status: string;
          userId?: string | null;
        };
      }
    | null;
};

export type SubmitBusinessEntityForReviewMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
}>;

export type SubmitBusinessEntityForReviewMutation = {
  __typename?: 'Mutation';
  submitBusinessEntityForReview?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'SubmitEntityForReviewResult'; entityId: string; oscilarWorkflowId: string }
    | null;
};

export type SubmitUboForReviewMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  businessEntityId: Scalars['ID']['input'];
  identificationMethod: UboIdentificationMethod;
}>;

export type SubmitUboForReviewMutation = {
  __typename?: 'Mutation';
  submitUBOForReview?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'SubmitEntityForReviewResult'; entityId: string; oscilarWorkflowId: string }
    | null;
};

export type UpdateBusinessCddMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  instance: Scalars['Int']['input'];
  businessCdd: UpdateBusinessCddInput;
}>;

export type UpdateBusinessCddMutation = {
  __typename?: 'Mutation';
  updateBusinessCDD?:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'UpdateBusinessCDDResult';
        businessCdd: {
          __typename?: 'BusinessCDD';
          workspaceId: string;
          instance: number;
          businessEntityId?: string | null;
          structure?: string | null;
          description?: string | null;
          isRegulatedIndustry?: boolean | null;
          holdFinancialLicenses?: boolean | null;
          hasUndergoneSignificantChanges?: boolean | null;
          changes?: string | null;
          strategicPartners?: string | null;
          industryVertical?: string | null;
          buyerSellerConnection?: string | null;
          sellersAsIntermediaries?: boolean | null;
          allowsCrossBorder?: boolean | null;
          countriesOfOperation?: Array<string | null> | null;
          beneficialOwners?: Array<string | null> | null;
          termsAgreedAt?: string | null;
          termsUrl?: string | null;
          created: string;
          licenses?: Array<{ __typename?: 'BusinessCDDLicense'; type: string; number: string } | null> | null;
        };
      }
    | null;
};

export type AuthorizeIndividualLegalEntityBasisTheorySessionMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  nonce: Scalars['String']['input'];
}>;

export type AuthorizeIndividualLegalEntityBasisTheorySessionMutation = {
  __typename?: 'Mutation';
  authorizeIndividualLegalEntityBasisTheorySession?:
    | { __typename: 'AuthorizeIndividualLegalEntityBasisTheorySessionResult'; success: boolean }
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type AuthorizePlatformEntityBasisTheorySessionMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  nonce: Scalars['String']['input'];
}>;

export type AuthorizePlatformEntityBasisTheorySessionMutation = {
  __typename?: 'Mutation';
  authorizePlatformEntityBasisTheorySession?:
    | { __typename: 'AuthorizePlatformEntityBasisTheorySessionResult'; success: boolean }
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | null;
};

export type GetLatestSchemaDraftQueryVariables = Exact<{
  schemaKey: Scalars['SafeString']['input'];
  workspaceId: Scalars['ID']['input'];
}>;

export type GetLatestSchemaDraftQuery = {
  __typename?: 'Query';
  schemaDrafts: {
    __typename?: 'SchemaDraftConnection';
    nodes: Array<{
      __typename: 'SchemaDraft';
      id: string;
      created: string;
      schemaKey: string;
      author: string;
      json: unknown;
    }>;
  };
};

export type GetSchemaDraftQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  schemaKey: Scalars['SafeString']['input'];
  workspaceId: Scalars['ID']['input'];
  created: Scalars['String']['input'];
}>;

export type GetSchemaDraftQuery = {
  __typename?: 'Query';
  schemaDraft:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | { __typename: 'NotFoundError'; code: string; message: string }
    | { __typename: 'SchemaDraft'; id: string; json: unknown; author: string; created: string; schemaKey: string };
};

export type ListSchemaDraftsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  schemaKey: Scalars['SafeString']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListSchemaDraftsQuery = {
  __typename?: 'Query';
  schemaDrafts: {
    __typename?: 'SchemaDraftConnection';
    nodes: Array<{
      __typename: 'SchemaDraft';
      id: string;
      author: string;
      created: string;
      schemaKey: string;
      json: unknown;
    }>;
    pageInfo: {
      __typename?: 'ReversiblePageInfo';
      hasNextPage: boolean;
      endCursor?: string | null;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  };
};

export type SaveSchemaDraftMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  schemaKey: Scalars['SafeString']['input'];
  author: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
}>;

export type SaveSchemaDraftMutation = {
  __typename?: 'Mutation';
  saveSchemaDraft:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'SaveSchemaDraftResult';
        draft: { __typename?: 'SchemaDraft'; created: string; id: string; schemaKey: string };
      };
};

export const OnErrorFragmentDoc = gql`
    fragment onError on Error {
  __typename
  code
  message
}
    `;
export const OnboardOnErrorFragmentDoc = gql`
    fragment onboardOnError on Error {
  code
  message
}
    `;
export const CreateApiClientDocument = gql`
    mutation CreateApiClient($workspaceId: ID!, $clientName: String!, $role: WorkspaceRoleKey!) {
  createApiClient(workspaceId: $workspaceId, clientName: $clientName, role: $role) {
    __typename
    ... on CreateApiClientResult {
      secret
      client {
        id
        clientName
        role
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useCreateApiClientMutation() {
  return Urql.useMutation<CreateApiClientMutation, CreateApiClientMutationVariables>(CreateApiClientDocument);
}
export const DeleteApiClientDocument = gql`
    mutation DeleteApiClient($workspaceId: ID!, $clientId: ID!) {
  deleteApiClient(workspaceId: $workspaceId, clientId: $clientId) {
    __typename
    ... on DeleteApiClientResult {
      success
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useDeleteApiClientMutation() {
  return Urql.useMutation<DeleteApiClientMutation, DeleteApiClientMutationVariables>(DeleteApiClientDocument);
}
export const GetWorkspaceApiClientDocument = gql`
    query GetWorkspaceApiClient($workspaceId: ID!) {
  workspace(id: $workspaceId) {
    __typename
    ... on Workspace {
      apiClients {
        __typename
        ... on WorkspaceApiClientsResult {
          nodes {
            id
            clientName
            role
          }
        }
        ...onError
      }
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useGetWorkspaceApiClientQuery(
  options: Omit<Urql.UseQueryArgs<GetWorkspaceApiClientQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetWorkspaceApiClientQuery, GetWorkspaceApiClientQueryVariables>({
    query: GetWorkspaceApiClientDocument,
    ...options,
  });
}
export const UpdateApiClientDocument = gql`
    mutation UpdateApiClient($workspaceId: ID!, $clientId: ID!, $role: WorkspaceRoleKey!) {
  updateApiClient(workspaceId: $workspaceId, clientId: $clientId, role: $role) {
    __typename
    ... on UpdateApiClientResult {
      client {
        id
        clientName
        role
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useUpdateApiClientMutation() {
  return Urql.useMutation<UpdateApiClientMutation, UpdateApiClientMutationVariables>(UpdateApiClientDocument);
}
export const CreateDataExportDocument = gql`
    mutation CreateDataExport($workspaceId: ID!, $dataExport: CreateDataExportInput!) {
  createDataExport(workspaceId: $workspaceId, dataExport: $dataExport) {
    __typename
    ... on CreateDataExportResult {
      dataExport {
        id
        exportBucketName
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useCreateDataExportMutation() {
  return Urql.useMutation<CreateDataExportMutation, CreateDataExportMutationVariables>(CreateDataExportDocument);
}
export const DeleteDataExportDocument = gql`
    mutation DeleteDataExport($workspaceId: ID!, $dataExportId: String!) {
  deleteDataExport(workspaceId: $workspaceId, dataExportId: $dataExportId) {
    __typename
    ... on DeleteDataExportResult {
      success
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useDeleteDataExportMutation() {
  return Urql.useMutation<DeleteDataExportMutation, DeleteDataExportMutationVariables>(DeleteDataExportDocument);
}
export const GetDataExportsDocument = gql`
    query GetDataExports($workspaceId: ID!) {
  workspace(id: $workspaceId) {
    __typename
    ... on Workspace {
      dataExports {
        __typename
        ... on WorkspaceDataExportsResult {
          nodes {
            id
            exportBucketName
            exportBucketRegion
            exportBucketKey
          }
        }
        ...onError
      }
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useGetDataExportsQuery(options: Omit<Urql.UseQueryArgs<GetDataExportsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDataExportsQuery, GetDataExportsQueryVariables>({
    query: GetDataExportsDocument,
    ...options,
  });
}
export const TestDataExportConnectionDocument = gql`
    mutation TestDataExportConnection($bucketName: String!, $bucketRegion: String) {
  testDataExportConnection(bucketName: $bucketName, bucketRegion: $bucketRegion) {
    __typename
    ... on TestDataExportConnectionResult {
      success
      errorMessage
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useTestDataExportConnectionMutation() {
  return Urql.useMutation<TestDataExportConnectionMutation, TestDataExportConnectionMutationVariables>(
    TestDataExportConnectionDocument,
  );
}
export const GetWorkspaceInvoicesDocument = gql`
    query GetWorkspaceInvoices($workspaceId: ID!) {
  workspace(id: $workspaceId) {
    ... on Workspace {
      __typename
      invoices {
        __typename
        ... on WorkspaceInvoicesConnection {
          nodes {
            __typename
            id
            amount
            billingPeriod
            status
          }
        }
        ...onError
      }
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useGetWorkspaceInvoicesQuery(
  options: Omit<Urql.UseQueryArgs<GetWorkspaceInvoicesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetWorkspaceInvoicesQuery, GetWorkspaceInvoicesQueryVariables>({
    query: GetWorkspaceInvoicesDocument,
    ...options,
  });
}
export const CreateCustomLinkDocument = gql`
    mutation CreateCustomLink($workspaceId: ID!, $name: String!, $ik: SafeString!) {
  createCustomLink(workspaceId: $workspaceId, name: $name, ik: $ik) {
    __typename
    ... on CreateCustomLinkResult {
      link {
        id
        entity
        originalName
        created
      }
      isIkReplay
    }
    ...onboardOnError
  }
}
    ${OnboardOnErrorFragmentDoc}`;

export function useCreateCustomLinkMutation() {
  return Urql.useMutation<CreateCustomLinkMutation, CreateCustomLinkMutationVariables>(CreateCustomLinkDocument);
}
export const GetLinkDocument = gql`
    query GetLink($workspaceId: ID!, $linkId: ID!) {
  workspace(id: $workspaceId) {
    __typename
    ... on Workspace {
      link(id: $linkId) {
        __typename
        ... on Link {
          id
          name: originalName
          created
          ... on IncreaseLink {
            increaseEnv
          }
          ... on UnitLink {
            unitEnv
            orgTokenLastUpdated
          }
          ... on StripeLink {
            stripeEnv
            rakLastUpdated
          }
        }
        ... on Error {
          code
          message
        }
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useGetLinkQuery(options: Omit<Urql.UseQueryArgs<GetLinkQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLinkQuery, GetLinkQueryVariables>({ query: GetLinkDocument, ...options });
}
export const LinkIncreaseDocument = gql`
    mutation LinkIncrease($workspaceId: ID!, $code: String!) {
  linkBnkDev(workspaceId: $workspaceId, code: $code) {
    __typename
    ... on LinkBnkDevResult {
      link {
        id
      }
    }
    ...onboardOnError
  }
}
    ${OnboardOnErrorFragmentDoc}`;

export function useLinkIncreaseMutation() {
  return Urql.useMutation<LinkIncreaseMutation, LinkIncreaseMutationVariables>(LinkIncreaseDocument);
}
export const LinkUnitDocument = gql`
    mutation LinkUnit($workspaceId: ID!, $unitOrgId: ID!, $env: LinkUnitEnv!, $disableSync: Boolean, $name: String!, $orgToken: String!) {
  linkUnit(
    workspaceId: $workspaceId
    unitOrgId: $unitOrgId
    env: $env
    disableSync: $disableSync
    name: $name
    orgToken: $orgToken
  ) {
    __typename
    ... on LinkUnitResult {
      link {
        id
        entity
        created
        originalName
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useLinkUnitMutation() {
  return Urql.useMutation<LinkUnitMutation, LinkUnitMutationVariables>(LinkUnitDocument);
}
export const OnboardIncreaseDocument = gql`
    mutation OnboardIncrease($workspaceId: ID!, $tempLinkId: ID!, $env: OnboardBnkDevEnv!, $disableSync: Boolean, $name: String) {
  onboardBnkDev(
    workspaceId: $workspaceId
    tempLinkId: $tempLinkId
    env: $env
    disableSync: $disableSync
    name: $name
  ) {
    __typename
    ... on OnboardBnkDevResult {
      link {
        __typename
        id
        entity
        originalName
        created
      }
    }
    ...onboardOnError
  }
}
    ${OnboardOnErrorFragmentDoc}`;

export function useOnboardIncreaseMutation() {
  return Urql.useMutation<OnboardIncreaseMutation, OnboardIncreaseMutationVariables>(OnboardIncreaseDocument);
}
export const OnboardStripeDocument = gql`
    mutation OnboardStripe($workspaceId: ID!, $code: String!, $env: StripeEnv!, $disableSync: Boolean, $name: String) {
  onboardStripe(
    workspaceId: $workspaceId
    code: $code
    env: $env
    disableSync: $disableSync
    name: $name
  ) {
    __typename
    ... on OnboardStripeResult {
      link {
        __typename
        id
        entity
        originalName
        created
      }
    }
    ...onboardOnError
  }
}
    ${OnboardOnErrorFragmentDoc}`;

export function useOnboardStripeMutation() {
  return Urql.useMutation<OnboardStripeMutation, OnboardStripeMutationVariables>(OnboardStripeDocument);
}
export const UpdateStripeLinkDocument = gql`
    mutation UpdateStripeLink($update: UpdateStripeLinkInput!) {
  updateStripeLink(input: $update) {
    __typename
    ... on UpdateStripeLinkResult {
      link {
        id
        name: originalName
        created
        stripeEnv
        rakLastUpdated
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useUpdateStripeLinkMutation() {
  return Urql.useMutation<UpdateStripeLinkMutation, UpdateStripeLinkMutationVariables>(UpdateStripeLinkDocument);
}
export const UpdateUnitLinkDocument = gql`
    mutation UpdateUnitLink($update: UpdateUnitLinkInput!) {
  updateUnitLink(input: $update) {
    __typename
    ... on UpdateUnitLinkResult {
      link {
        id
        name: originalName
        created
        unitEnv
        orgTokenLastUpdated
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useUpdateUnitLinkMutation() {
  return Urql.useMutation<UpdateUnitLinkMutation, UpdateUnitLinkMutationVariables>(UpdateUnitLinkDocument);
}
export const CreateLiveBlocksReadTokenDocument = gql`
    mutation CreateLiveBlocksReadToken($workspaceId: ID!, $roomId: String!) {
  createLiveBlocksReadToken(workspaceId: $workspaceId, roomId: $roomId) {
    __typename
    ... on CreateLiveBlocksTokenResult {
      accessToken
      roomId
    }
    ... on Error {
      __typename
      code
      message
    }
  }
}
    `;

export function useCreateLiveBlocksReadTokenMutation() {
  return Urql.useMutation<CreateLiveBlocksReadTokenMutation, CreateLiveBlocksReadTokenMutationVariables>(
    CreateLiveBlocksReadTokenDocument,
  );
}
export const CreateLiveBlocksWriteTokenDocument = gql`
    mutation CreateLiveBlocksWriteToken($workspaceId: ID!, $roomId: String!) {
  createLiveBlocksWriteToken(workspaceId: $workspaceId, roomId: $roomId) {
    __typename
    ... on CreateLiveBlocksTokenResult {
      accessToken
      roomId
    }
    ... on Error {
      __typename
      code
      message
    }
  }
}
    `;

export function useCreateLiveBlocksWriteTokenMutation() {
  return Urql.useMutation<CreateLiveBlocksWriteTokenMutation, CreateLiveBlocksWriteTokenMutationVariables>(
    CreateLiveBlocksWriteTokenDocument,
  );
}
export const CreateMcpAuthorizationGrantDocument = gql`
    mutation CreateMcpAuthorizationGrant($workspaceId: ID!, $issuerState: String!, $clientName: String) {
  createMcpAuthorizationGrant(
    workspaceId: $workspaceId
    issuerState: $issuerState
    clientName: $clientName
  ) {
    __typename
    ... on CreateMcpAuthorizationGrantResult {
      grantToken
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useCreateMcpAuthorizationGrantMutation() {
  return Urql.useMutation<CreateMcpAuthorizationGrantMutation, CreateMcpAuthorizationGrantMutationVariables>(
    CreateMcpAuthorizationGrantDocument,
  );
}
export const DeleteMcpClientDocument = gql`
    mutation DeleteMcpClient($workspaceId: ID!, $clientId: ID!) {
  deleteMcpClient(workspaceId: $workspaceId, clientId: $clientId) {
    __typename
    ... on DeleteMcpClientResult {
      success
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useDeleteMcpClientMutation() {
  return Urql.useMutation<DeleteMcpClientMutation, DeleteMcpClientMutationVariables>(DeleteMcpClientDocument);
}
export const GetWorkspaceMcpClientsDocument = gql`
    query GetWorkspaceMcpClients($workspaceId: ID!) {
  workspace(id: $workspaceId) {
    __typename
    ... on Workspace {
      mcpClients {
        __typename
        ... on WorkspaceMcpClientsResult {
          nodes {
            id
            name
            userId
          }
        }
        ...onError
      }
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useGetWorkspaceMcpClientsQuery(
  options: Omit<Urql.UseQueryArgs<GetWorkspaceMcpClientsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetWorkspaceMcpClientsQuery, GetWorkspaceMcpClientsQueryVariables>({
    query: GetWorkspaceMcpClientsDocument,
    ...options,
  });
}
export const GetWorkspaceByIdDocument = gql`
    query GetWorkspaceById($workspaceId: ID!) {
  workspace(id: $workspaceId) {
    __typename
    ... on Workspace {
      __typename
      id
      inviteEnabled
      inviteCode
      defaultCurrency
      name
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useGetWorkspaceByIdQuery(options: Omit<Urql.UseQueryArgs<GetWorkspaceByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWorkspaceByIdQuery, GetWorkspaceByIdQueryVariables>({
    query: GetWorkspaceByIdDocument,
    ...options,
  });
}
export const GetIndividualEntityDocument = gql`
    query GetIndividualEntity($workspaceId: ID!, $entityId: ID!) {
  individualEntity(workspaceId: $workspaceId, entityId: $entityId) {
    __typename
    ... on GetIndividualEntityResult {
      individualEntity {
        id
        type
        piiDataTokenId
        status
        userId
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useGetIndividualEntityQuery(
  options: Omit<Urql.UseQueryArgs<GetIndividualEntityQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetIndividualEntityQuery, GetIndividualEntityQueryVariables>({
    query: GetIndividualEntityDocument,
    ...options,
  });
}
export const GetPaymentPlatformEntityDocument = gql`
    query GetPaymentPlatformEntity($workspaceId: ID!) {
  paymentPlatformEntity(workspaceId: $workspaceId) {
    __typename
    ... on GetPaymentPlatformEntityResult {
      platformEntity {
        id
        type
        piiDataTokenId
        status
        controllers {
          id
          type
          status
          userId
        }
        owners {
          id
          type
          status
          userId
        }
      }
      businessCdd {
        workspaceId
        instance
        businessEntityId
        structure
        description
        isRegulatedIndustry
        holdFinancialLicenses
        licenses {
          type
          number
        }
        hasUndergoneSignificantChanges
        changes
        strategicPartners
        industryVertical
        buyerSellerConnection
        sellersAsIntermediaries
        allowsCrossBorder
        countriesOfOperation
        beneficialOwners
        termsAgreedAt
        termsUrl
        created
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useGetPaymentPlatformEntityQuery(
  options: Omit<Urql.UseQueryArgs<GetPaymentPlatformEntityQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetPaymentPlatformEntityQuery, GetPaymentPlatformEntityQueryVariables>({
    query: GetPaymentPlatformEntityDocument,
    ...options,
  });
}
export const InviteIndividualOnboardingApplicationDocument = gql`
    mutation InviteIndividualOnboardingApplication($workspaceId: ID!, $userId: ID!, $email: String!, $role: IndividualOnboardingRole!) {
  inviteIndividualOnboardingApplication(
    workspaceId: $workspaceId
    userId: $userId
    email: $email
    role: $role
  ) {
    __typename
    ... on InviteIndividualOnboardingApplicationResult {
      individualEntity {
        id
        type
        piiDataTokenId
        status
        userId
      }
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useInviteIndividualOnboardingApplicationMutation() {
  return Urql.useMutation<
    InviteIndividualOnboardingApplicationMutation,
    InviteIndividualOnboardingApplicationMutationVariables
  >(InviteIndividualOnboardingApplicationDocument);
}
export const SubmitBusinessEntityForReviewDocument = gql`
    mutation SubmitBusinessEntityForReview($workspaceId: ID!, $legalEntityId: ID!) {
  submitBusinessEntityForReview(
    workspaceId: $workspaceId
    legalEntityId: $legalEntityId
  ) {
    __typename
    ... on SubmitEntityForReviewResult {
      entityId
      oscilarWorkflowId
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useSubmitBusinessEntityForReviewMutation() {
  return Urql.useMutation<SubmitBusinessEntityForReviewMutation, SubmitBusinessEntityForReviewMutationVariables>(
    SubmitBusinessEntityForReviewDocument,
  );
}
export const SubmitUboForReviewDocument = gql`
    mutation SubmitUBOForReview($workspaceId: ID!, $legalEntityId: ID!, $businessEntityId: ID!, $identificationMethod: UboIdentificationMethod!) {
  submitUBOForReview(
    workspaceId: $workspaceId
    legalEntityId: $legalEntityId
    businessEntityId: $businessEntityId
    identificationMethod: $identificationMethod
  ) {
    __typename
    ... on SubmitEntityForReviewResult {
      entityId
      oscilarWorkflowId
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useSubmitUboForReviewMutation() {
  return Urql.useMutation<SubmitUboForReviewMutation, SubmitUboForReviewMutationVariables>(SubmitUboForReviewDocument);
}
export const UpdateBusinessCddDocument = gql`
    mutation UpdateBusinessCDD($workspaceId: ID!, $instance: Int!, $businessCdd: UpdateBusinessCDDInput!) {
  updateBusinessCDD(
    workspaceId: $workspaceId
    instance: $instance
    businessCdd: $businessCdd
  ) {
    __typename
    ... on UpdateBusinessCDDResult {
      businessCdd {
        workspaceId
        instance
        businessEntityId
        structure
        description
        isRegulatedIndustry
        holdFinancialLicenses
        licenses {
          type
          number
        }
        hasUndergoneSignificantChanges
        changes
        strategicPartners
        industryVertical
        buyerSellerConnection
        sellersAsIntermediaries
        allowsCrossBorder
        countriesOfOperation
        beneficialOwners
        termsAgreedAt
        termsUrl
        created
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useUpdateBusinessCddMutation() {
  return Urql.useMutation<UpdateBusinessCddMutation, UpdateBusinessCddMutationVariables>(UpdateBusinessCddDocument);
}
export const AuthorizeIndividualLegalEntityBasisTheorySessionDocument = gql`
    mutation AuthorizeIndividualLegalEntityBasisTheorySession($workspaceId: ID!, $entityId: ID!, $nonce: String!) {
  authorizeIndividualLegalEntityBasisTheorySession(
    workspaceId: $workspaceId
    entityId: $entityId
    nonce: $nonce
  ) {
    __typename
    ... on AuthorizeIndividualLegalEntityBasisTheorySessionResult {
      success
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useAuthorizeIndividualLegalEntityBasisTheorySessionMutation() {
  return Urql.useMutation<
    AuthorizeIndividualLegalEntityBasisTheorySessionMutation,
    AuthorizeIndividualLegalEntityBasisTheorySessionMutationVariables
  >(AuthorizeIndividualLegalEntityBasisTheorySessionDocument);
}
export const AuthorizePlatformEntityBasisTheorySessionDocument = gql`
    mutation AuthorizePlatformEntityBasisTheorySession($workspaceId: ID!, $nonce: String!) {
  authorizePlatformEntityBasisTheorySession(
    workspaceId: $workspaceId
    nonce: $nonce
  ) {
    __typename
    ... on AuthorizePlatformEntityBasisTheorySessionResult {
      success
    }
    ...onError
  }
}
    ${OnErrorFragmentDoc}`;

export function useAuthorizePlatformEntityBasisTheorySessionMutation() {
  return Urql.useMutation<
    AuthorizePlatformEntityBasisTheorySessionMutation,
    AuthorizePlatformEntityBasisTheorySessionMutationVariables
  >(AuthorizePlatformEntityBasisTheorySessionDocument);
}
export const GetLatestSchemaDraftDocument = gql`
    query GetLatestSchemaDraft($schemaKey: SafeString!, $workspaceId: ID!) {
  schemaDrafts(workspaceId: $workspaceId, schemaKey: $schemaKey, last: 1) {
    nodes {
      __typename
      id
      created
      schemaKey
      author
      json
    }
  }
}
    `;

export function useGetLatestSchemaDraftQuery(
  options: Omit<Urql.UseQueryArgs<GetLatestSchemaDraftQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLatestSchemaDraftQuery, GetLatestSchemaDraftQueryVariables>({
    query: GetLatestSchemaDraftDocument,
    ...options,
  });
}
export const GetSchemaDraftDocument = gql`
    query GetSchemaDraft($id: ID!, $schemaKey: SafeString!, $workspaceId: ID!, $created: String!) {
  schemaDraft(
    id: $id
    schemaKey: $schemaKey
    workspaceId: $workspaceId
    created: $created
  ) {
    __typename
    ... on SchemaDraft {
      id
      json
      author
      created
      schemaKey
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useGetSchemaDraftQuery(options: Omit<Urql.UseQueryArgs<GetSchemaDraftQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSchemaDraftQuery, GetSchemaDraftQueryVariables>({
    query: GetSchemaDraftDocument,
    ...options,
  });
}
export const ListSchemaDraftsDocument = gql`
    query ListSchemaDrafts($workspaceId: ID!, $schemaKey: SafeString!, $first: Int, $after: String, $last: Int, $before: String) {
  schemaDrafts(
    workspaceId: $workspaceId
    schemaKey: $schemaKey
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      __typename
      id
      author
      created
      schemaKey
      json
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    `;

export function useListSchemaDraftsQuery(options: Omit<Urql.UseQueryArgs<ListSchemaDraftsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListSchemaDraftsQuery, ListSchemaDraftsQueryVariables>({
    query: ListSchemaDraftsDocument,
    ...options,
  });
}
export const SaveSchemaDraftDocument = gql`
    mutation SaveSchemaDraft($workspaceId: ID!, $schemaKey: SafeString!, $author: String!, $schema: JSON!) {
  saveSchemaDraft(
    workspaceId: $workspaceId
    schemaKey: $schemaKey
    author: $author
    schema: $schema
  ) {
    __typename
    ... on SaveSchemaDraftResult {
      draft {
        created
        id
        schemaKey
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useSaveSchemaDraftMutation() {
  return Urql.useMutation<SaveSchemaDraftMutation, SaveSchemaDraftMutationVariables>(SaveSchemaDraftDocument);
}
